"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Presets_1 = require("./Presets");
const TargetContext_1 = tslib_1.__importDefault(require("./TargetContext"));
const TargetUtils_1 = require("./TargetUtils");
/**
 *
 * @deprecated TargetProvider is not needed anymore. Get the values directly instead by
 *
 * ```typescript
 *   import { getApiUrl, getTargetMeta } from "@mne-core/providers/Target";
 *   const apiUrl = getApiUrl();
 *   const { apiUrl, baseUrl, metaInfo, domain, env, ...} = getTargetMeta();
 *```
 */
const TargetProvider = (props) => {
    const { children, preset = "auto" } = props;
    const targetCtx = (0, react_1.useMemo)(() => {
        const _preset = preset === "auto" ? (0, Presets_1.presetFromUrl)(window.location.host) : preset;
        const { apiUrl, strutsUrl, staticUrl, baseUrl, spaUrl, ...rest } = Presets_1.Presets[_preset];
        return {
            ...rest,
            apiUrl,
            baseUrl,
            spaUrl,
            staticUrl,
            strutsUrl,
            toApiUrl: TargetUtils_1.toApiUrl,
            toSpaUrl: TargetUtils_1.toSpaUrl,
            toStaticUrl: TargetUtils_1.toStaticUrl,
            toStrutsUrl: TargetUtils_1.toStrutsUrl,
        };
    }, [preset]);
    return react_1.default.createElement(TargetContext_1.default.Provider, { value: targetCtx }, children);
};
exports.default = TargetProvider;
